import React from "react";

import Icon from '../../atoms/Icon/icon';
import styles from "./MainApp.layouts.ExtraMenuItem.module.scss";

const ExtraMenuItem = ({title, arrow}) => {
    return(
        <div className={styles["extra-menu-item-container"]}>
            <p className={styles["extra-menu-item-title"]} >{title}</p>
            {arrow && <Icon name="chevron-right" width={8} height={16} fill={"#3C7AF5"}/>}
        </div>
    )
}

export default ExtraMenuItem